// @ts-nocheck
import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Colors } from "../constants/colors";

export const LeftGradientLine = styled.div(() => ({
    flex: 1,
    height: 1,
    background: `linear-gradient(270deg, ${Colors.vampireBlack15} 0%, ${Colors.ateneoBlue} 100%)`,
}));

export const RightGradientLine = styled.div(() => ({
    flex: 1,
    height: 1,
    background: `linear-gradient(90deg, ${Colors.vampireBlack15} 0%, ${Colors.ateneoBlue} 100%)`,
}));

export const ReferEarnContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: theme.spacing.xLarge,
    paddingBottom: theme.spacing.small,
    paddingLeft: theme.spacing.xSmall,
    paddingRight: theme.spacing.xSmall,
    marginTop: theme.spacing.xSmall,
}));

export const ReferEarnText = styled(Text)(({ theme }) => ({
    margin: theme.spacing.xxSmall,
    color: theme.colors[theme.colorMode].text_High_Emphasis,
}));

export const HomePageContainer = styled.div(({ theme }) => ({
    padding: theme.spacing.medium,
    backgroundColor: theme.colors[theme.colorMode].background_Secondary,
    minHeight: "100%",
}));

export const CardsContainer = styled.div(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "50% 50%",
    gap: theme.spacing.xSmall,
}));

export const MastheadImageContainer = styled.div(() => ({
    width: "100%",
    height: "auto",
    display: "block",
    position: "relative",
}));

export const MastheadImage = styled(Image)(() => ({
    width: "100%",
    height: "auto",
    objectFit: "contain" as const,
    display: "block",
}));

export const ShuttleAppName = styled.div({
    display: "none",
});
